module.exports = __webpack_public_path__ + "static/media/sign-CI.c878d578.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/products/sign-CI.svg
// module id = 85
// module chunks = 0